/**
 * The dashboard's sign-in screen.
 *
 * The credentials are the same WordPress ones Robert uses for the Academy site
 * — no separate password, and no email code to wait for, which is what made
 * the Cloudflare Access login unusable (issue #4).
 */
import React, { useState } from 'react';
import { login } from './auth';
import './Login.css';

interface LoginProps {
  onSignedIn: (displayName: string) => void;
}

const Login: React.FC<LoginProps> = ({ onSignedIn }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const displayName = await login(username, password);
      onSignedIn(displayName);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <h1>Academy Dashboard</h1>
        <p className="login-hint">Sign in with your WordPress account.</p>

        <label htmlFor="login-username">Username or email</label>
        <input
          id="login-username"
          type="text"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          autoFocus
        />

        <label htmlFor="login-password">Password</label>
        <input
          id="login-password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <div className="login-error" role="alert">{error}</div>}

        <button type="submit" disabled={busy || !username || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default Login;
